import React from "react";
import { Link, useLocation } from "react-router-dom";

export default function LegalLink({ to, children, className }) {
  const location = useLocation();
  return (
    <Link to={to} state={location.state} className={className}>
      {children}
    </Link>
  );
}
